import axios from "axios";
import { baseURL } from "../thunks";

export const getTrash = () => async (dispatch) => {
  const { data } = await axios.get(baseURL + "documentation/trash/root", {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return data;
};
